<template>
    <section id="about-process" class="blog-details article">
        <article class="article">
            <h2 class="title">Understanding Electrolysis Hair Removal</h2>

            <div class="content">
                <p>
                    This process uses a tiny probe that delivers electrical current to destroy the hair growth cells.
                </p>

                <blockquote>
                    <p>
                        "Electrolysis is the only method of permanent hair removal endorsed by the FDA,
                        offering lasting results for all skin and hair types."
                    </p>
                </blockquote>

                <h3>The Process of Electrolysis</h3>
                <p>
                    During treatment, a very fine probe is inserted into the hair follicle. A small
                    amount of electrical current is then applied, effectively destroying the hair growth
                    cells, preventing future hair growth in that follicle.
                </p>

                <h3>Benefits and Results</h3>
                <p>
                    Unlike other hair removal methods, electrolysis offers permanent results. It works
                    on all skin types, hair colors, and most areas of the body. Results are progressive,
                    with each treatment bringing you closer to permanent hair removal.
                </p>
            </div>
        </article>
    </section>
</template>

<script>
export default {
    name: 'AboutProcess'
}
</script>